import TableCellSpace from "ds/components/Table/Row/CellSpace";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Plugin } from "types/generated";

const PluginsTableSpaceCell = ({ item: plugin, ...cellProps }: TableSimpleCellProps<Plugin>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellSpace href={`/spaces/${plugin.spaceDetails.id}`}>
        {plugin.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default PluginsTableSpaceCell;
